import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from '@/app/services/core.service';
import { InformacionService } from '@/app/services/informacion.service';
import Swal from 'sweetalert2';
import { ReenvioJustificacionComponent } from '@/app/components/cargas/reenvio-justificacion/reenvio-justificacion.component';
import { CargaService } from '@/app/services/carga.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';

@Component({
    selector: 'app-enviar-carga',
    templateUrl: './enviar-carga.component.html',
    styleUrls: ['./enviar-carga.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnviarCargaComponent {

  isValid: boolean = false;
  private spinner = inject(NgxSpinnerService);

  cargaRQ = {
    idCarga: '',
    equipo: '',
    idEquipo: '',
    tipoCombustible: '',
    cantidadCombustible: '',
    costoActualCombustible: '',
    cuentaCredito: '',
    cuentaDebito: '',
  }

  idEstatus: string = '';
  justificacion: string = '';

  //validaciones
    hasFinished: boolean = false;
    seReenvio: boolean = false;
    responseReenvio: boolean = false;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<EnviarCargaComponent>,
    private informacionService: InformacionService,
    private cargaService: CargaService,
    private coreService: CoreService,
    private dialog: MatDialog,
    private userTokenReaderService: TokenReaderService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    let {idCarga, isValid, idEstatus, seReenvio, justificacion } = data;
    
    this.isValid = isValid;
    this.idEstatus = idEstatus;
    this.seReenvio = seReenvio;
    this.justificacion = justificacion;

    this.getInfoCombustible(idCarga);
  }

  getInfoCombustible(idCarga: string){
    this.spinner.show();
    this.informacionService.getInfoCombustible(idCarga).subscribe({       
      next: (data: any) => {
        this.spinner.hide();
        this.cargaRQ.idCarga = idCarga;
        if(data != null && data.Info != null){
          let info = data.Info[0];
          this.cargaRQ.equipo = info['Equipo'];
          this.cargaRQ.idEquipo = info['idEquipo'];
          this.cargaRQ.tipoCombustible = info['tipoCombustible'];
          this.cargaRQ.cantidadCombustible = info['cantidadCombustible'];
          this.cargaRQ.costoActualCombustible = info['costoActualCombustible'];
          this.cargaRQ.cuentaCredito = info['cuentaCredito'];
          this.cargaRQ.cuentaDebito = info['CuentaDebito'];
        }
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }



  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas aprobar la carga?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => {
        if(result.value){
          this.enviarCarga();
        }
      });
    }
  }

  enviarCarga(){
    this.spinner.show();

    let autorizacionRQ = {
      idCarga: this.cargaRQ.idCarga,
      idUsuario: this.userTokenReaderService.getUserData().idUsuario,
    }

    this.cargaService.autorizacionCarga(autorizacionRQ).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Carga Aprobada.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished && !this.isValid){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha aprobado la carga. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      if(!this.isValid || this.responseReenvio){
        this.dialogRef.close({updateList: true, seReenvio: this.responseReenvio});
      }else{
        this.dialogRef.close({updateList: false});
      }
      
    }
  }

  //para abrir modal de reenvio carga
    abrirModalReenvio(){
      const dialogRef = this.dialog.open(ReenvioJustificacionComponent, {
        width: '450px',
        height: '350px',
        data: { idCarga: this.cargaRQ.idCarga, idEstatus: this.idEstatus, seReenvio: this.seReenvio, justificacion: this.justificacion },
        panelClass: 'custom-dialog-container',
        disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result.updateList) {
          if(result.seReenvio){
            this.responseReenvio = true;
          }
          this.hasFinished = true;
          this.onClose();
        } 
      });
  
      this.router.events.subscribe(() => {
        dialogRef.close();
      });
    }
}
